<template>
  <div class="setting bg-white" :style="{minHeight:minHeight+'px'}">
    <headerCom>
      <div class="setting-menu flex-lm">
        <div :class="['setting-menu-single font-size16 flex-cm',item.use ? (item.isactive ? 'green-font' : '') : 'gray-font']" v-for="(item,index) in settingmenu" style="justify-content: flex-start;" @click="switchinfo(index)">{{item.name}}</div>
        <div class="menu-line bg-green" :style="{left:settingmenu[0].isactive ? 0 : 109+'px'}"></div>
      </div>
    </headerCom>
    <div class="setting-all">
      <div :hidden="!settingmenu[0].isactive">
        <div class="flex-lr" style="padding:20px;">
          <div class="black-font font-size18">关联的公众号</div>
          <div class="bg-green white-font font-size14 concat-button flex-cm" @click="toaccount">关联账号</div>
        </div>
        <div class="concat-account-list">
          <div class="account-header flex-lr gray-font font-size14">
            <div class="">公众号名称</div>
            <div class="">操作</div>
          </div>
          <div class="account-tr flex-lr" v-for="item in openlist">
            <div class="black-font font-size14">{{item.nick_name}}</div>
            <div class="flex-rr green-font font-size14 account-tr-button">删除</div>
          </div>
        </div>
      </div>
      <div class="account-person" :hidden="!settingmenu[1].isactive">
        <div class="person-basic" style="margin-bottom: 40px;">
          <div class="font-size18 black-font">基础信息</div>
          <div class="flex-lm basic-info">
            <div class="flex-lm" style="margin-right: 100px;align-items: flex-end">
              <div class="font-size14 black-font">头像：</div>
              <img :src="userinfo.headerimg"/>
            </div>
            <div style="height:80px;padding-top: 20px;box-sizing: border-box;justify-content: flex-end;" class="flex-vc">
              <div class="flex-lr" style="width: 500px;margin-bottom: 20px;">
                <div class="flex-lm"  style="margin-right: 100px;">
                  <div class="font-size14 black-font">名字：</div>
                  <div class="black-font font-size16">{{userinfo.name}}</div>
                </div>
                <div class="flex-lm">
                  <div class="font-size14 black-font">手机号：</div>
                  <div class="black-font font-size16">{{userinfo.phone ? userinfo.phone : ''}}</div>
                </div>
              </div>
              <div class="flex-lr" style="width: 500px;">
                <div class="flex-lm"  style="margin-right: 100px;">
                  <div class="font-size14 black-font">邮箱：</div>
                  <div class="black-font font-size16">{{userinfo.email ? userinfo.email : ''}}</div>
                </div>
                <div class="flex-lm">
                  <div class="font-size14 black-font">微信号：</div>
                  <div class="black-font font-size16">{{userinfo.wechat ? userinfo.wechat : ''}}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import headerCom from '../header.vue'
  export default {
    name: 'download',
    data () {
      return {
        minHeight:window.innerHeight-82,
        openid:JSON.parse(localStorage.getItem('userinfo')).openid,
        settingmenu:[
          {
            name:'关联设置',
            isactive:true,
            mark:'concat',
            use:true
          },
          {
            name:'账户信息',
            isactive:false,
            mark:'account',
            use:true
          },
          // {
          //   name:'不可选文字',
          //   isactive:false,
          //   mark:'select',
          //   use:false
          // }
        ],
        auth_code:'',
        openlist:[],
        userinfo:JSON.parse(localStorage.getItem('userinfo'))
      }
    },
    components:{
      headerCom
    },
    methods:{
     toaccount(){
      this.$router.push({
        path:'/accounteg'
      })
     },
     getopenlist(){
      this.$http({
        url:'https://pfotoo.com?s=App.User.GetAuthorizerByopenid'+this.$getsign(),
        params:{
          openid:this.openid
        },
        method:'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        console.log(res.body,'rrrrrr')
        let json=res.body;
        if(res.body.ret==200){
          console.log(json)
          if(JSON.stringify(json.data)!="{}"){
            this.openlist=json.data;
          }
        }
      })
     },
     switchinfo(index){
       if(index==0){
         this.settingmenu[1].isactive=false;
       }else{
         this.settingmenu[0].isactive=false;
       }
        this.settingmenu[index].isactive=true;
     },
    },
    mounted(){
      this.getopenlist();
       console.log('http://www.pfotoo.com/?auth_code=queryauthcode@@@Hn4jUzLpwMUSTBmzPHujqQJHNa_2vYe8iUleMJyX1kJQKVC_jE6dzpAoFjgYyhKpbdyTHoBmUPp6sxk93vQIzw&expires_in=3600#/'.split('=')[1].split('&')[0].split('queryauthcode@@@')[1])
    },

  }
</script>

<style>
  .setting{
    width:100%;
    padding-left:10px;
  }
  .setting-menu{
    width:100%;
    padding-top:10px;
    position: relative;
  }
  .menu-line{
    width: 64px;
    height: 2px;
    position: absolute;
    left:0;
    top:58px;
    transition: left .3s ease;
  }
  .setting-menu-single{
    height:45px;
    margin-right:45px;
    cursor: pointer;
  }
  .concat-button{
    width:80px;
    height:35px;
    border-radius:4px;
    cursor: pointer;
  }
  .concat-account-list{
    width:100%;
    padding:0 20px;
    box-sizing: border-box;
  }
  .account-header{
    width:100%;
    height:60px;
    background: #EEF2F2;
    border-radius:8px;
    padding:0 30px;
    box-sizing: border-box;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .account-tr{
    width:100%;
    height:60px;
    padding:0 30px;
    box-sizing: border-box;
    border:1px solid #EEF2F2;
    border-top:0;
  }
  .account-tr-button{
    width:100px;
    height:100%;
    cursor: pointer;
  }
  .account-person{
    width:100%;
    padding:30px 20px;
    box-sizing: border-box;
  }
  .account-person img{
    width: 80px;
    height: 80px;
  }
  .basic-info{
    padding-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/list/setting.vue